import * as React from "react";
import { ApiErrorInterface } from "../../../interfaces/ApiErrorResponseInterface";
import styles from "./styles.scss";

interface ApiErrorsProps {
  errors: ApiErrorInterface[];
}

export const ApiErrors: React.FC<ApiErrorsProps> = ({ errors }) => {
  if (errors.length === 0) {
    return null;
  }

  return (
    <>
      {errors.map((err: ApiErrorInterface, idx: number) => (
        <p key={`karte_template-error-${idx}`} className={styles.errors}>
          {err.message}
        </p>
      ))}
    </>
  );
};
